<app-avatar [name]="selected()?.name ?? ''" [seed]="selected()?.id ?? null" size="sm"></app-avatar>
<mat-select (valueChange)="value.set($event)" [aria-label]="label()" [value]="value()" panelWidth="auto">
    @for (person of people(); track person.id) {
        <mat-option [value]="person.id">{{ person.name }}{{ person.suffix ? ' ' + person.suffix : '' }}</mat-option>
    }
</mat-select>
<button (click)="step(-1)" [disabled]="people().length < 2" aria-label="Vorige persoon" type="button">
    <i class="fa-regular fa-chevron-up"></i>
</button>
<button (click)="step(1)" [disabled]="people().length < 2" aria-label="Volgende persoon" type="button">
    <i class="fa-regular fa-chevron-down"></i>
</button>
